import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { FadeLoader } from 'react-spinners';
import { useSelector } from "react-redux";
import SettingForm from "./CloudSettingForm";
import { dataExportsAPI } from "../../../api";
import { getUserSession } from "../../../utils/auth";
import '../../../styles/dataExports/index.css';
import '../../../styles/dataExports/SettingForm.css';

const ScheduleSending = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [scheduledSettings, setScheduledSettings] = useState(null);
    const [refresh, setRefresh] = useState("");
    const [error, setError] = useState(null);
    const userEmail = localStorage.getItem('email')
    const businessToken=""
    
    const fetchUserResponse = useSelector(state => state.fetchUserResponse);
    const businesses = fetchUserResponse?.businesses;
    const [editingScheduledSetting, setEditingScheduledSetting] = useState({});
    const [showSettingForm, setShowSettingForm] = useState(false);
    // QuickMenu state
    const [activeMenuItem, setActiveMenuItem] = useState('analytics');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    useEffect(() => {
      const fetchScheduledSettings = async () => {
        setLoading(true); // Set loading to true at start

        let idToken = await getUserSession();

        if (!idToken) {
          toast.error('No authentication token found. Please sign in again.');
          setTimeout(() => {
            navigate('/auth/signin');
          }, 1000); // Delay navigation for 3 seconds (3000ms)
          return;
        }
        
        try {
          const response = await dataExportsAPI.get(`/cloud-delivery-settings/${userEmail}`, {
            params: { business_token: businessToken },
            headers: {
              'Authorization': idToken
            }
          });
          setScheduledSettings(response.data.data);
        } catch (err) {
          setError(err.message);
          toast.error(`${err.message}. ${err.response?.data?.message || ''}`);
        }
        
        // Always wait 3 seconds before turning off loading state
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      };
      
      fetchScheduledSettings();
    }, [userEmail, businessToken, refresh]);
    
    
    return (
      <>
            {/* QuickMenu Sidebar */}
        <div style={{width: "100%", minHeight: "80vh", padding: "20px"}}>
            {/* <h3 style={{textAlign:"center"}}>Scheduled Delivery</h3> */}
            { loading 
              ? <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "100%"}}>
                <div style={{marginBottom:"20px"}}>Loading...</div>
                <FadeLoader loading={loading} size={16} color={"white"}/>
              </div>
              :scheduledSettings && scheduledSettings.length > 0 ?
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "100%"}}>
                      <div>
                        {
                          scheduledSettings.map((scheduledSetting, index) => (
                            <div key={index}>
                              <BloomsTab scheduledSetting={scheduledSetting} 
                              setEditingScheduledSetting={setEditingScheduledSetting}
                              editingScheduledSetting={editingScheduledSetting}
                              />
                            </div>
                          ))
                        }
                      </div>
                      {
                        businesses.length > scheduledSettings.length && !showSettingForm && !(editingScheduledSetting && Object.keys(editingScheduledSetting).length > 0) &&
                        <button className="schedule-delivery-create-new-btn" 
                          style={{maxWidth: "600px", marginTop:"10px"}} onClick={() => setShowSettingForm(true)}>
                          Create New Scheduled Setting
                        </button>
                      }
                    </div>
                    : <div>
                        <div className="schedule-delivery-main-content">
                          <div className="schedule-delivery-content-center">
                            <h1>Scheduled Cloud Delivery</h1>
                            <p>No scheduled cloud settings found, please create a new one.</p>
                            {
                              !showSettingForm &&
                              <button className="schedule-delivery-create-new-btn" onClick={() => setShowSettingForm(true)}>
                                Create New Scheduled Setting
                              </button>
                            }
                          </div>
                        </div>
                    </div>
            }

            {
                (showSettingForm || editingScheduledSetting && Object.keys(editingScheduledSetting).length > 0)&&
                <SettingForm scheduledSetting={editingScheduledSetting} 
                  setEditingScheduledSetting={setEditingScheduledSetting} 
                  setRefresh={setRefresh}
                  setShowSettingForm={setShowSettingForm}
                />
            }

        </div>
        </>
    );
};

export default ScheduleSending;




const BloomsTab = ({scheduledSetting, setEditingScheduledSetting, editingScheduledSetting, }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const updated_at = new Date(scheduledSetting.updated_at).toLocaleString();

  const toggleExpand = () => {
    if (editingScheduledSetting.id) {
      setIsExpanded(false);
      return
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="blooms-container">
      <div className="blooms-tab">
        {/* Tab Header */}
        <div className="blooms-header" onClick={toggleExpand}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div>
              <h2 className="blooms-title">{scheduledSetting.business_name}</h2>
              <div className="blooms-subtitle">Last modified: {updated_at}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className={`blooms-toggle ${isExpanded ? 'expanded' : ''}`}></span>
              <button className="blooms-edit-btn" 
                disabled={Object.keys(editingScheduledSetting).length > 0} 
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the click event from bubbling up to the header
                  setEditingScheduledSetting(scheduledSetting); 
                  setIsExpanded(false);}
                }>
                {editingScheduledSetting.id === scheduledSetting.id ? 'Editing' : 'Edit'}
              </button>
            </div>
          </div>

          <div className="blooms-row" style={{padding: "10px 0 0 0"}}>
          <div className="blooms-column">
              <div className="blooms-label">Host</div>
              <div className="blooms-value">{
                scheduledSetting.cloud_credential_type === "aws-rds" ? "AWS RDS" 
                : scheduledSetting.cloud_credential_type === "gcp-cloud-sql" ? "Google Cloud SQL"
                : "Unknown"
              }</div>
            </div>
            <div className="blooms-column">
              <div className="blooms-label">Sites</div>
              <div className="blooms-value">{scheduledSetting.sites.length} Selected</div>
            </div>
            <div className="blooms-column">
              <div className="blooms-label">Tables</div>
              <div className="blooms-value">{scheduledSetting.table_configs.length} selected</div>
            </div>
            <div className="blooms-column">
              <div className="blooms-label">Schedule</div>
              <div className="blooms-value">{scheduledSetting.frequency.split("_").map(
                (word) => word.charAt(0).toUpperCase() + word.slice(1)).join(", ")}</div>
            </div>
          </div>

        </div>
        
        {/* Expandable Content */}
        <div className={`blooms-content ${isExpanded ? 'expanded' : ''}`}>

          <div className="blooms-row">
            <div className="blooms-column" style={{ width: '100%' }}>
              <div className="blooms-label">Sites</div>
              <div className="blooms-list">
                {
                  scheduledSetting.sites.map((site, index) => (
                    <div key={index} className="blooms-list-item">{site.site_name}</div>
                  ))
                }
              </div>
            </div>
          </div>
          
          {/* Fourth Row: Selected Tables */}
          <div className="blooms-row">
            <div className="blooms-column" style={{ width: '100%' }}>
              <div className="blooms-label">Selected Tables</div>
              <div className="blooms-list">
                {
                  scheduledSetting.table_configs.map((table, index) => (
                    <div key={index} className="blooms-list-item">{table.name}</div>
                  ))
                }
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};